/** `/` — opens the app on the person's company, or says they have none here. */
import type { JSX } from "react";
import { Navigate, createFileRoute } from "@tanstack/react-router";
import { AuthSplash } from "@linkhr/auth/pages";
import { ErrorScreen } from "@linkhr/design-system";
import { useMePermissions } from "../api/useMePermissions";
import { homeCompanyId } from "../shell/gate";

export const Route = createFileRoute("/_auth/")({
  component: OpenHome,
});

function OpenHome(): JSX.Element {
  const permissions = useMePermissions();
  if (permissions.data === undefined && permissions.isError) {
    return <ErrorScreen error={permissions.error} reset={() => void permissions.refetch()} />;
  }
  // Wait out a re-read too: after a lost company the cached answer still lists it.
  if (permissions.data === undefined || permissions.isFetching) return <AuthSplash />;
  const companyId = homeCompanyId(permissions.data);
  return companyId === null ? (
    <Navigate to="/no-access" replace />
  ) : (
    <Navigate to="/c/$companyId" params={{ companyId }} replace />
  );
}
